module.exports = __webpack_public_path__ + "img/3-1.b44016e3.png";